export default "__VITE_ASSET__Dq3uKQ9S__"